/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NotificationBellIcon24Solid = forwardRef('NotificationBellIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M12 2C7.726 2 4.262 5.47 4.262 9.75v4.377a.388.388 0 0 1-.075.23L2.244 17.01C1.639 17.837 2.228 19 3.25 19h17.5c1.022 0 1.61-1.163 1.006-1.99l-1.943-2.653a.388.388 0 0 1-.075-.23V9.75C19.738 5.47 16.274 2 12 2Z" }),
        React.createElement("path", { d: "M12 23a3 3 0 0 1-3-3h6a3 3 0 0 1-3 3Z" })));
});
